import { Button } from '@/common/ui/button'
import { Plus, Info } from 'lucide-react'
import { Link } from 'react-router-dom'
import ShopTable from '@/modules/shop/components/ShopTable'
import ShopItemPresetGallery from '@/modules/shop/components/ShopItemPresetGallery'
import type { components } from '@/schema'

type ShopItem = components['schemas']['AdminShopItemResponse'] & {
	price?: number
}

interface ShopItemsListingProps {
	data: ShopItem[]
	total: number
	isLoading: boolean
}

export default function ShopItemsListing({
	data,
	total,
	isLoading,
}: ShopItemsListingProps) {
	return (
		<div className="space-y-8">
			{/* Header with actions */}
			<div className="flex items-center justify-between">
				<h2 className="text-2xl font-semibold">
					จัดการสินค้า ({total} รายการ)
				</h2>
				<Button asChild>
					<Link to="/operator/shop/items/create">
						<Plus className="mr-2 h-4 w-4" />
						เพิ่มสินค้าใหม่
					</Link>
				</Button>
			</div>

			{/* Diamond source info banner */}
			<div className="flex items-start gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm dark:border-blue-800 dark:bg-blue-950/30">
				<Info className="mt-0.5 h-4 w-4 shrink-0 text-blue-600 dark:text-blue-400" />
				<div className="text-blue-800 dark:text-blue-200">
					<p className="font-medium">
						ผู้เล่นได้รับเพชรจากกิจกรรมเช็คอินรายวันและกิจกรรมกงล้อนำโชค
					</p>
					<p className="mt-0.5">
						หากสินค้าในร้านใช้เพชรในการแลก กรุณาตรวจสอบให้แน่ใจว่ากิจกรรม{' '}
						<Link
							to="/operator/daily-check-in"
							className="font-medium underline underline-offset-2 hover:text-blue-900 dark:hover:text-blue-100"
						>
							เช็คอินรายวัน
						</Link>{' '}
						และ{' '}
						<Link
							to="/operator/lucky-wheel"
							className="font-medium underline underline-offset-2 hover:text-blue-900 dark:hover:text-blue-100"
						>
							กงล้อนำโชค
						</Link>{' '}
						ได้รับการตั้งค่าให้แจกเพชร
						และแจกในจำนวนที่เหมาะสมสอดคล้องกับราคาสินค้าในร้าน
					</p>
				</div>
			</div>

			{/* Preset gallery */}
			<ShopItemPresetGallery />

			{/* Table */}
			<ShopTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
